@if (showModal()) {
<div class="error-logout-modal">
  <div class="modal-content">
    <div class="modal-flex-row">
      <div class="icon-col">
        <span class="icon-circle"><span class="icon-exclamation">!</span></span>
      </div>
      <div class="content-col">
        <div class="headline">Unable to login</div>
        <div class="subtext">Please sign out and try again.</div>
      </div>
    </div>
    <div class="button-row">
      <button class="modal-action-btn" (click)="onSignOut()">SIGN OUT</button>
    </div>
  </div>
</div>
}
